import { Container, Text } from './styles';

export interface DeliveryWindowProps {
  timeRange: string;
  textColor: string;
  isWindowAvailable: boolean;
}

export const DeliveryWindow = ({ timeRange, textColor, isWindowAvailable }: DeliveryWindowProps) => {
  return (
    <Container>
      <Text textColor={textColor}>{timeRange}</Text>
      <Text textColor={textColor}>{isWindowAvailable ? 'Free' : 'Unavailable'}</Text>
    </Container>
  );
};
